module.exports = __webpack_public_path__ + "static/img/secondBox.e2c4b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/secondBox.png
// module id = hdZG
// module chunks = 1